import { formatUnit } from "@/lib/lorryApi";

/**
 * Escape a single CSV cell value.
 * - Wraps in quotes if it contains comma, quote, newline or leading zero-widths
 * - Escapes internal quotes by doubling them
 */
function escapeCell(val) {
  if (val === null || val === undefined) return "";
  const s = String(val);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

function todayStamp() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportLorriesToCsv(lorries) {
  const headers = [
    "Registration",
    "Product",
    "Load Amount",
    "Unit",
    "Driver",
    "Date",
    "Status",
    "Notes",
    "Created At",
  ];

  const rows = lorries.map((l) => [
    l.registration,
    l.product,
    l.load_amount,
    formatUnit(l.load_unit),
    l.driver_name,
    l.date,
    (l.status || "").toUpperCase(),
    l.notes || "",
    l.created_at || "",
  ]);

  const csv =
    [headers, ...rows].map((r) => r.map(escapeCell).join(",")).join("\r\n") + "\r\n";

  // Prepend BOM so Excel opens UTF-8 correctly
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `loadyard-${todayStamp()}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 500);

  return rows.length;
}
